module.exports = __webpack_public_path__ + "static/animal-app-logo-f7ff0598b589d7dd275cb1b9c226745d.png";